const InteractivesArea = ({ children }) => {
  return (
    <div className="interactiveContainer">
      <div className="interactiveShelf">{children}</div>
      <div className="shelfArea">
        <img className="shelfImage" src="images/shelf.png" alt="" />
      </div>
    </div>
  )
}

export default InteractivesArea
